import React from 'react';
import { FormattedMessage } from 'react-intl';

// import NonApiSelection from '../Screen3.5/NonApiSelection';
import { QuickSubscriptionPicker } from '../Screen6';
// import { BasicInfo } from '../Screen3';
// import DestinationConnector from '../Screen4';
// import { LetsGoButton, WelcomeRocket, WelcomeSubtitle, WelcomeTitle } from '../Screen1';
import { LetsGoButton } from '../Screen1';
// import ReadyToLaunchAdvanced from '../AdvancedScreen7';
// import ReadyToLaunch from '../Screen7';
import { Welcome } from '../Screen0';
import { ThankYou } from '../Screen2';

export default {
  steps: [
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      content: <Welcome />,
      showProgress: true,
      showBackground: true,
      title: <FormattedMessage id="onboarding.screen0.title" />,
      subtitle: <FormattedMessage id="onboarding.screen0.subtitle" />,
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: '',
      currentStage: 0,
      storeActionBeforeNext: 'updateBasicInfo',
      // showSkip: true,
      // skipHeight: 131,
      languageButton: true
    },
    // {
    //   // default
    //   target: 'body',
    //   placement: 'center',
    //   // other
    //   content: <BasicInfo />,
    //   showProgress: true,
    //   showBackground: true,
    //   title: <FormattedMessage id="onboarding.screen3.title" />,
    //   subtitle: <FormattedMessage id="onboarding.screen3.subtitle" />,
    //   primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
    //   secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
    //   currentStage: 1,
    //   // showSkip: true,
    //   // skipHeight: 131,
    //   storeActionBeforeNext: 'updateBasicInfo',
    // },
    // {
    //   // default
    //   target: 'body',
    //   placement: 'center',
    //   // other
    //   content: <NonApiSelection />,
    //   showProgress: true,
    //   showBackground: true,
    //   title: <FormattedMessage id="onboarding.screen3.5.title" />,
    //   primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
    //   secondaryButtonContent: '',
    //   currentStage: 1,
    //   bigContent: true,
    //   // showSkip: true,
    //   // skipHeight: 131,
    //   storeActionBeforeNext: 'updateBasicInfo',
    // },
    {
      target: 'body',
      content: <QuickSubscriptionPicker />,
      title: <FormattedMessage id="onboarding.screen6.title" />,
      showProgress: true,
      showBackground: true,
      placement: 'center',
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.back" />,
      biggerContent: true,
      currentStage: 1,
      skipHeight: 80,
    },
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      content: <ThankYou />,
      currentStage: 2,
      showProgress: true,
      showBackground: true,
      title: <FormattedMessage id="onboarding.ThankYou" />,
      primaryButtonContent: <LetsGoButton />,
      secondaryButtonContent: '',
    },
    // {
    //   // default
    //   target: 'body',
    //   placement: 'center',
    //   // other
    //   title: <FormattedMessage id="onboarding.screen4.title" />,
    //   subtitle: <FormattedMessage id="onboarding.screen4.subtitle" />,
    //   // subtitle: <WelcomeSubtitle />,
    //   showBackground: true,
    //   content: <DestinationConnector />,
    //   showProgress: true,
    //   bigContent: true,
    //   primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
    //   secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
    //   currentStage: 3,
    // },
    // {
    //   target: 'body',
    //   content: (
    //     <div
    //       style={{
    //         display: 'flex',
    //         minHeight: '270px',
    //         alignItems: 'center',
    //         justifyContent: 'space-around',
    //       }}
    //     >
    //       <ReadyToLaunch />
    //       <ReadyToLaunchAdvanced forOnboarding width="300px" />
    //     </div>
    //   ),
    //   title: <FormattedMessage id="onboarding.advanced.screen7.title" />,
    //   subtitle: <FormattedMessage id="onboarding.advanced.screen7.subtitle" />,
    //   showProgress: true,
    //   showBackground: true,
    //   placement: 'center',
    //   primaryButtonContent: <FormattedMessage id="settingsModal.import" />,
    //   secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
    //   currentStage: 4,
    //   showSkip: true,
    //   bigContent: true,
    //   skipHeight: 28,
    //   storeActionBeforeNext: 'importCSV',
    // },
    // {
    //   // default
    //   target: 'body',
    //   placement: 'center',
    //   // other
    //   content: <WelcomeRocket />,
    //   bigContent: true,
    //   currentStage: 5,
    //   showProgress: false,
    //   title: <WelcomeTitle />,
    //   subtitle: <WelcomeSubtitle />,
    //   primaryButtonContent: <LetsGoButton />,
    //   secondaryButtonContent: '',
    //   showBackground: false,
    // },
  ],
};
